import Service from './Service';

class MercadoPagoService extends Service {
  static createCheckout(productID: string): Promise<{ init_point: string }> {
    return this.Http.post<{ init_point: string }>('/mp/checkout', { productID }).then(this.getData);
  }

  static getSubscription(): Promise<{ active: boolean; subscription?: any }> {
    return this.Http.get<{ active: boolean; subscription?: any }>('/mp/subscription').then(this.getData);
  }
}

export default MercadoPagoService;
